import UserApiKeyModelBase from '../_generated/modelBases/user-api-key-model-base';

export default class UserApiKeyModel extends UserApiKeyModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
